<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/o1WDnu/tc-custom/9781633539174.jpg?1718183452837" alt="This image is the cover for the book Thoughts on Synergy, The 7 Habits"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Thoughts on Synergy, The 7 Habits
      </h1>
      <p class="bookDescription body article font2">
        <b>Quotes and writings from the <i>New York Times</i>–bestselling author to help reinforce one of his 7 Habits: Synergize.</b><br/><br/>This concise, standalone book is part of a seven-book series called the Portable 7 Habits. These easy-to-read books are designed to quickly and effectively reinforce <i>The 7 Habits Of Highly Effective People</i> by Stephen R. Covey, each focusing on a different habit.<br/><br/>In <i>Thoughts on</i><i>Synergy: Connecting to the Power of Cooperation</i>, you will discover a collection of writings and quotes that support Covey’s Habit 6: Synergize. Synergy will teach you that 1+1 is greater than 2, and that it’s not only your way or my way—together there is a better and higher way. The power of cooperation helps us find solutions for problems—today and in the future.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Stephen R. Covey
      </h2>
      
      <p class="authorDescription body article">FranklinCovey is a global, public company specializing in organizational performance improvement. We help organizations and individuals achieve results that require a change in human behavior. Our expertise is in seven areas: leadership, execution, productivity, trust, sales performance, customer loyalty and education. FranklinCovey clients have included 90 percent of the Fortune® 100, more than 75 percent of the Fortune® 500, thousands of small and mid-sized businesses, as well as numerous government entities and educational institutions. FranklinCovey has more than 100 direct and partner offices providing professional services in over 150 countries and territories.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      RosettaBooks, LLC
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?fb10ab8e